import { NavigationError } from '@angular/router';

/**
 * Recover from a lazy route chunk that no longer exists on the server.
 *
 * After a deploy, a browser still running the previous bundle asks for chunk
 * names the new release no longer has. Hosting's SPA rewrite answers with
 * index.html, the dynamic import fails, and the router used to fall back to a
 * blank `/` (CLUB-2179). Reloading the target URL once fetches the current
 * bundle. The session flag stops a reload loop if the chunk really is broken.
 */

const RELOAD_FLAG = 'ce-chunk-reload';

/** Chromium, Firefox and Safari word a failed dynamic import differently. */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i.test(
    message,
  );
}

export function recoverFromChunkLoadError(
  event: NavigationError,
  storage: Pick<Storage, 'getItem' | 'setItem'> | null = safeSessionStorage(),
  reload: (url: string) => void = (url) => window.location.assign(url),
): void {
  if (!isChunkLoadError(event.error)) return;
  if (storage?.getItem(RELOAD_FLAG) === event.url) return;
  storage?.setItem(RELOAD_FLAG, event.url);
  reload(event.url);
}

function safeSessionStorage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}
